import styled from 'styled-components';
import {Label} from '@tickchak/react-share/app';
import {dFlex, dFlexColumn, dFlexStartBetween, alignStart} from '../../../../../globalVariables/GlobalFlex';
import {desktopMedia, mobileMedia, DARK_GRAY, WHITE} from '../../../../../globalVariables/GlobalVariables';
import zIndex from '../../../../../globalVariables/zIndex';
import ContactRep from './ContactRep/ContactRep';

export const wrapper = styled.div`
    position: relative;
    width: 100%;
    ${dFlexColumn}
    gap: var(--space-md);
    background: ${p => p.theme.isDarkMode ? DARK_GRAY : 'var(--color-bg-base)'};
    border: var(--space-xs) solid var(--primitive-yellow-300);
    border-radius: var(--radius-lg);
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.2); /* no shadow token in react-share */
    padding: var(--space-lg);
    color: ${p => p.theme.isDarkMode ? WHITE : 'var(--color-text-default)'};
    ${desktopMedia}{
        padding: var(--space-2xl);
        border-width: var(--space-sm);
    }
`;

export const headerRow = styled.div`
    ${dFlexStartBetween}
    flex-wrap: wrap;
    gap: var(--space-md);
    width: 100%;
    ${desktopMedia}{
        flex-wrap: nowrap;
    }
`;

export const headerActions = styled.div`
    ${dFlex}
    ${alignStart}
    gap: var(--space-md);
    position: absolute;
    top: var(--space-lg);
    inset-inline-end: var(--space-lg);
    z-index: ${zIndex.baseRaised};
    ${desktopMedia}{
        position: static;
        /* reserve room for the Window's built-in "?" (24px icon, window.css) sitting at the card corner */
        margin-inline-end: calc(24px + var(--space-md));
    }
`;

export const grid = styled.div`
    width: 100%;
    display: grid;
    gap: var(--space-sm);
    grid-template-columns: 1fr;
    grid-template-areas: "rocket" "revenue" "conversion" "profit" "roi" "visits";
    ${desktopMedia}{
        grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(0, 240px);
        grid-template-areas:
            "revenue conversion visits rocket"
            "roi     profit     .      rocket";
    }
`;

export const rocketPicture = styled.picture`
    grid-area: rocket;
    place-self: center;
    max-width: 100%;
    max-height: 100%;
`;

export const rocketImg = styled.img`
    width: 100%;
    max-width: 100%;
    height: auto;
    object-fit: contain;
    ${desktopMedia}{
        width: auto;
        max-height: 100%;
    }
`;

export const headerContactRep = styled(ContactRep)`
    ${mobileMedia}{
        display: none;
    }
`;

export const mobileContactRep = styled(ContactRep)`
    ${desktopMedia}{
        display: none;
    }
`;

export const badge = styled(Label)`
    && {
        height: 24px;
        padding-inline: var(--space-sm);
        font-size: var(--font-size-caption);
        ${p => p.theme.isDarkMode && `
            background-color: rgba(255,255,255,0.14);
            color: ${WHITE};
        `}
    }
`;
